export default "__VITE_ASSET__CYfIsrEs__"